import { render } from "./Cookie.vue?vue&type=template&id=5b73180f"
import script from "./Cookie.vue?vue&type=script&lang=ts"
export * from "./Cookie.vue?vue&type=script&lang=ts"
script.render = render

export default script